import { Button } from "@/components/ui/button";
import { useNavigate } from "@tanstack/react-router";
import { useUserAppInfo } from "@/hooks/useUserAppInfo";
import { ArrowLeft, EllipsisVertical } from "lucide-react";
import { useDimensions } from "@/hooks/useDimensions";
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup } from "@/components/ui/dropdown-menu";
import { DropdownMenuTrigger } from "@radix-ui/react-dropdown-menu";
import { StatusPill } from "../StatusPill";
import { AdminFormAction } from "./AdminFormAction";
import { useState } from "react";

interface IProps {
  userAppId: string;
}

export const PVPAppFormAdminFooter: React.FC<IProps> = ({ userAppId }) => {
  const backLink = "/admin/pvp";
  const { isSmallScreen } = useDimensions();
  const navigate = useNavigate();
  const { appStatus, isActionable } = useUserAppInfo(userAppId);
  const [open, setOpen] = useState(false);

  return (
    <>
      <footer className={`flex flex-row items-center justify-between border-t border-slate-300 bg-white p-4 md:px-6`}>
        <Button
          className="border border-slate-300 bg-slate-100"
          variant="secondary"
          onClick={() => {
            navigate({
              to: backLink,
            });
          }}
        >
          <div className="flex flex-row items-center justify-between text-sm">
            <ArrowLeft className="slate-900 mr-2 h-4 w-4" />
            {isSmallScreen ? "Exit" : "Exit Application"}
          </div>
        </Button>
        <div className="flex flex-row flex-wrap gap-4">
          {isSmallScreen ? (
            <DropdownMenu open={open} onOpenChange={setOpen}>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" size="icon">
                  <EllipsisVertical />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-56">
                <DropdownMenuGroup className="flex flex-col gap-2 p-2">
                  <AdminFormAction disabled={!isActionable} userAppId={userAppId} action="reject" onActionComplete={() => setOpen(false)} />
                  <AdminFormAction
                    disabled={!isActionable}
                    userAppId={userAppId}
                    action="requestAmendments"
                    onActionComplete={() => setOpen(false)}
                  />
                  <AdminFormAction
                    disabled={!isActionable}
                    userAppId={userAppId}
                    action="approve"
                    onActionComplete={() => setOpen(false)}
                  />
                </DropdownMenuGroup>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <>
              {isActionable ? (
                <>
                  <AdminFormAction disabled={!isActionable} userAppId={userAppId} action="reject" />
                  <AdminFormAction disabled={!isActionable} userAppId={userAppId} action="requestAmendments" />
                  <AdminFormAction disabled={!isActionable} userAppId={userAppId} action="approve" />
                </>
              ) : (
                <StatusPill applicationStatus={appStatus} />
              )}
            </>
          )}
        </div>
      </footer>
    </>
  );
};
